export enum DeliveryNoteReaderType {
    ADOBE_PDF = 'ADOBE_PDF',
    BMW_CSV = 'BMW_CSV',
    STOCKEASY_PDF = 'STOCKEASY_PDF',
}

export const DeliveryNoteReaderTypeDescriptions: Record<DeliveryNoteReaderType, string> = {
    [DeliveryNoteReaderType.ADOBE_PDF]: 'Adobe PDF',
    [DeliveryNoteReaderType.BMW_CSV]: 'BMW CSV',
    [DeliveryNoteReaderType.STOCKEASY_PDF]: 'Stockeasy PDF',
};
